module.exports = __webpack_public_path__ + "1ab8cda6ad51ac114b07db2e929ba278.png";